module.exports = __webpack_public_path__ + "static/media/Press-3.a629eb3d.png";